import TaskType from './model';

export default TaskType;



// WEBPACK FOOTER //
// ./data/Tasks/TaskType/index.js